import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { AlertController, IonDatetime, ModalController, NavController, PopoverController } from '@ionic/angular';
import { AppServiceService } from 'src/app/api/app-service.service';
import { StorageService } from 'src/app/core/storage.service';
import { InputSelectModalComponent } from 'src/app/component/input-select-modal/input-select-modal.component';
import { OTPVerificationPage } from '../modals/otp-verification/otp-verification.page';
import { TranslateService } from '@ngx-translate/core';
import { CartPage } from '../modals/cart/cart.page';
import { SelectOrderTypePage } from '../modals/select-order-type/select-order-type.page';
import { CalendarPage } from '../modals/calendar/calendar.page';
import { InputSelectModalPointsComponent } from 'src/app/component/input-select-modal-points/input-select-modal-points.component';
import { CustomConfirmDialogComponent } from 'src/app/component/custom-confirm-dialog/custom-confirm-dialog.component';
import { DeliveryTimesPage } from '../modals/delivery-times/delivery-times.page';
import { Router } from '@angular/router';

declare var config: any;
@Component({
  selector: 'app-checkout-new',
  templateUrl: './checkout-new.page.html',
  styleUrls: ['./checkout-new.page.scss'],
})
export class CheckoutNewPage implements OnInit {
  @Output() onNavigatePages: EventEmitter<any> = new EventEmitter();
  @Output() onChangeDeliveryAddress: EventEmitter<any> = new EventEmitter();
  @Output() onOrderPlaced: EventEmitter<any> = new EventEmitter();
  @Output() onOrderPlaceError: EventEmitter<any> = new EventEmitter();
  @Input() backFromAddressSelect = false;
  // user decide to go back and login to the account for purchase rewards (points system change for web version)
  @Output() onBackLoginFromCheckout: EventEmitter<any> = new EventEmitter();

  @ViewChild('googleaddressbackary', { read: oninput }) googleaddressbackary: any;

  // otp verifgication template for web view
  @ViewChild('otpVerification') otpVerificationTemp: TemplateRef<any>;

  // catch all ion-datepickers to force open date picker content,
  // otherwise it only open when user tap on the selected date text
  @ViewChild('startDatePicker') startDatePicker: IonDatetime;
  @ViewChild('endDatePicker') endDatePicker: IonDatetime;
  @ViewChild('specialDatePicker') specialDatePicker: IonDatetime;

  // Recharge success popuop content template
  @ViewChild('rechargeSuccess') rechargeSuccess: TemplateRef<any>;
  public successPayment:any = null;

  public addressEditableViewEnabled: boolean = false;

  public selectedDate: any;
  public deleveryAvailableTimes: any = [];
  public deliveryDates: any = [];
  public selectedTimes: any = [];

  
  public paymentModal;
  
  public isTextAreaDisabled = false;

  public todayDate: any;
  public specialMinDate: any;
  public maxDate: any;

  public selectedTimesLoading: boolean = false;

  public currentlySelectedAddress = '';

  /**
   * Address book data of the user
   */
  public userAddressesList: any[] = [];
  public postalCodeAddress: any[] = [];
  public normalAddress: any[] = [];

  // address modal object for the address form
  public addressForm = {
    name: '',
    mobile_number: '',
    city: '',
    postal_code: '',
    street: '',
    street_number: '',
    address: '',
    backyard: '',
    lat: '',
    lng: '',
    email: '',
    company: null
  }
  // this will contains errors of the address form
  // make it easier to display validation errors on each input
  public addressFormValidator: any = {};

  public addressEditable: boolean = false;

  // last selected address details from the address book list
  public selectedAddressDetailsFromTheBook: any = null;

  // this will be filled by the addressForm object,
  // once user edit and save an address addressForm object will be assigned to this variable after validation process
  public currentlySelectedAddressData: any = null;
  // a boolean to check if we have valid address data to continue the checkout process
  public haveValidAddressDataFromGoogle: boolean = false;
  // postal code details selected by the user when ordering process start
  public postalCodeDetails: any = {
    code: '',
    name: ''
  };

  public userDetailsLoading: boolean = false;

  // if logged in user has already earned points, those will assign to this variable
  public userPoints: any = null;
  // point system configurations
  public pointConfig: any = null;
  // check if the user has required point amount that need for checkout current order
  public isOrderAmountPointsReached: boolean = false;
  // total required points to pay for the current order
  public totalPointRequirement: string = '';
  // has reached minimum order point amount defined in points configurations
  public isMinimumPointsAmountReached: boolean = false;

  private streetAddressGoogleInputInitialized: boolean = false;

  // display asap option
  public displayAsapOption: boolean = false;

  // selected date and time for normal order process
  public selectedDeliveryDateValue: string = '';
  public selectedDeliveryTimeValue: string = '';

  // show / hide menu categories not available error message
  public showMenuCategoriesNotAvailableError: boolean = false;
  public showSpecialOrderNotAvailableError: boolean = false;

  // unavailable menu categories list from menu category availability functiun
  public unavailableMenus: any[] = []
  // user has selected or only available subscription order method
  public is_subscription_order: boolean = false;
  // this will contains days that user scheduled subscription orders to deliver each week
  public selectedSubscribtionDates: string[] = [];

  // predefined week days as in menu category availability configurations
  public daysOfWeek = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];

  // weekly or daily, daily was deprecated but still use this variable coz if we gonna remove this that will be a really mess right now
  public order_schedule_type: string = 'weekly';
  // user will select mon/sat/sun etc in subscription mode, those values will be here
  public order_days: any = [];

  // this will be used when user verficiation process start if the user haven't verified when checkout
  // depends on backend verification requirements
  public verificationInProgress: boolean = false;

  // change this to true when debuging, will enable some of console logs that I ve put some places to make it easier to debug issues
  public debugOn: boolean = false;
  // dsiplay select valid address from google error message under address/street inputs
  public showSelectAddressError: boolean = false;
  // display select at least one day in subscription ordering mode schedule days select list 
  public showSelectDaysError: boolean = false;
  // display end date is required error on subscription order process
  public showEndDateError: boolean = false;
  // display start date is required error on subscription order process
  public showSelectStartDateError: boolean = false;

  public showSelectSpecialDateError: boolean = false;
  // subscription order start and end dates in string
  public subscriptionOrderStartDate: string = '';
  public subscriptionOrderEndDate: string = '';
  // this will indicate to the user the date he gets the first order delivered
  public subscriptionOrderActualStartDate: string = '';

  public specialDate: string = '';

  public subscriptionHasEndDate: boolean = false;

  // default order type can be subscription mode or genaral order mode
  public defaultOrderType: string = '';
  // if subscribtion mode is disabled, this will be true
  public isSubscriptionModeDisabled: boolean = false;

  public subscription_order_cutoff_time: any = '';
  public subscription_order_cutoff_days: any = '';

  public special_order_cutoff_time: any = '';
  public special_order_cutoff_days: any = '';

  // show subscription order end date cannot be grater than start date error
  public showEndDateCannotBeGraterThanStartDateError: boolean = false;
  // selected payment method for continue checkout
  public selectedPaymanetMethod: string = '';
  // this is selected payment method object from the option list, usefull for displaying on the ui
  public selectedPaymanetMethodObject: any = null;

  // display payment method is required error
  public showSelectPaymentMethodError: boolean = false;

  public lang: any;
  // order form special note
  public orderInstructions: string = '';

  // will display a warnning for changing addresses
  public addressSelectActionTriggered: boolean = false;

  public isSubscriptionOrderModeEnabled: boolean = false;

  public isGenaralOrderModeEnabled: boolean = false;

  public isGenaralSpecialOrderModeEnabled: boolean = false;

  public isAboutToTriggerStartDateChange: boolean = false;

  // OTP Verification Page Verification response object for web version
  public otpCodeResponse: { sentVia: string, userData: any, operationType: string } | null = null;

  // Avaliable subscription days and day's cutoff days
  public availableSubscriptionDays: any = {};

  // Avaliable special days and day's cutoff days
  public availableSpecialDays: any = {};
  
  public specialOpenCloseMsg: string = '';
  public subscriptionOpenCloseMsg: string = '';
  public subscriptionOpenCloseData: any = [];
  public subscriptionOpenOnlyCloseData: any = [];
  public showSpecialOpenCloseError: boolean = false;
  public showSubscriptionOpenCloseError: boolean = false;

  //only allowed subscription mode when restaurant is closed
  public allowOnlySubscriptionMode: boolean = false;

  public onInitBool: boolean = true;

  public showSelectTimeError:boolean = false;

  public initialDeliveryCost:any = null;

  // Tips feature related variables
  public isTipsEnabled:boolean = false;
  public tipsMessage:string = '';
  public predefinedTipAmounts:number[] = [];
  public allowCustomTipAmounts:boolean = false;
  public selectedTipAmount:string = '';
  public selectedTipAmountInNumber:number = null;
  public isTipRecurring:boolean = false;
  public tipApplied:boolean = false;

  public dateCannotBeEmpty:boolean = false;

  // to check currently available only PreOrder or not
  public isPreOrderOnly:boolean = false;

  // Debounce for custom street input field
  public debounceTimeout: ReturnType<typeof setTimeout> | null = null;

  
  constructor(public appService: AppServiceService, public storage: StorageService, private modalCtrl: ModalController, public translate: TranslateService, public popoverCtrl: PopoverController, private router:Router) {
    // this will make the floating cart button to display top right corner of the display instead of bottom right
    this.appService.className2 = ' cart-top';

    if(config.plf === 'app'){
      this.appService.watchPointsRechargeFromCheckoutPage().subscribe(async (successPayment) => {
        // appService.showToast('data : ' + JSON.stringify(successPayment), 'success',60000);
        if (successPayment && successPayment.status && successPayment.historyRecord) {
          this.successPayment = successPayment.historyRecord;
          let extraDetails = this.successPayment.extra_details ? JSON.parse(this.successPayment.extra_details) : null;
          if(extraDetails && extraDetails.forcedToRecharge){
            const modal = await this.modalCtrl.create({
              component: InputSelectModalComponent,
              cssClass: 'select-modal',
              componentProps: {
                content: this.rechargeSuccess
              },
            });
            // hide cart button when popup opening
            this.appService.hideCartButton = true;
    
            modal.present();
            // console.log(modal);
            modal.onWillDismiss().then(async (event) => {
              this.getUserDetails();
              this.appService.hideCartButton = false;
            });
          }
        }
      });
    }
  }


  ngOnInit() {
    let settingsLoadInt = setInterval(async () => {
      // this will make the floating cart button to display top right corner of the display instead of bottom right
      this.appService.className2 = ' cart-top';
      if (this.appService.isSettingsLoaded) {
        clearInterval(settingsLoadInt);

        if(!this.appService.isWebVersion) await this.appService.getRestaurantBySlug(this.appService.appObject.selectedRestaurantDetails.slug);

        // New custom street input mode for postal code with driver app disabled
        if(this.appService.appObject.selectedRestaurantDetails.disableGoogleAutoComplete){
            this.appService.disableGoogleAutoComplete = true;   
        }
        
        
        // if not delivery order, then make address is editable
        // that form contains name and mobile number, no address needed
        if (this.appService.appObject.selectedDeliveryMethod !== 'delivery') {
          this.addressEditable = true;
        }

        // if user has selected posal code somewhere in the ordering process, it will be stored in appObject
        // take postal code details from there..
        if (this.appService.appObject.selectedDeliveryMethod === 'delivery' && this.appService.appObject.selectedRestaurantDetails && this.appService.appObject.settings.is_postalcode === 'true') {
          this.postalCodeDetails = this.appService.appObject.postalCodeDetails;

          this.addressForm.city = this.postalCodeDetails.name;
          this.addressForm.postal_code = this.postalCodeDetails.code;
        }

        // keep initial delivery cost on construct
        this.initialDeliveryCost = this.appService.appObject.orderObject.cart_summery.delivery_cost;

        // if user has already logged in get user details and fill the available data in the form
        if (this.appService.appObject.isAuthed) {
          this.getUserDetails();
        } else {
          this.updateFormData();
        }

        // get available delivery dates and times
        this.getDeliveryTimes();

        // get order configurations from the selected restaurant 
        let subscription_order_button = this.appService.appObject.selectedRestaurantDetails.subscription_order_button;
        let general_order_button = this.appService.appObject.selectedRestaurantDetails.general_order_button;
        let general_order_special_mode = this.appService.appObject.selectedRestaurantDetails.general_order_special_mode;
        this.defaultOrderType = this.appService.appObject.selectedRestaurantDetails.default_order_type;

        this.isSubscriptionOrderModeEnabled = subscription_order_button === 'true' ? true : false;
        this.isGenaralOrderModeEnabled = general_order_button === 'true' ? true : false;
        this.isGenaralSpecialOrderModeEnabled = general_order_special_mode === 'true' ? true : false;

        if (subscription_order_button === 'true' && general_order_button !== 'true' && general_order_special_mode !== 'true') {
          this.isSubscriptionModeDisabled = true;
        }

        if (this.defaultOrderType === '"general_order"') {
          this.is_subscription_order = false;
        }
        if (this.defaultOrderType === 'subscription_order') {
          this.confirm_Popup_Coupon_Not_Supported();
          this.is_subscription_order = true;
        }

        var subscription_cutofftime = this.appService.appObject.selectedRestaurantDetails?.subscription_order_cutoff_time;
        if (subscription_cutofftime !== null) {
          this.subscription_order_cutoff_time = JSON.parse(this.appService.appObject.selectedRestaurantDetails?.subscription_order_cutoff_time)?.subscription_order_cutoff_time;
          // this.subscription_order_cutoff_days = this.appService.appObject.selectedRestaurantDetails?.subscription_order_cutoff_day;
        }

        var general_cutofftime = this.appService.appObject.selectedRestaurantDetails?.general_order_cutoff_time;
        if (general_cutofftime !== null) {
          this.special_order_cutoff_time = JSON.parse(this.appService.appObject.selectedRestaurantDetails?.general_order_cutoff_time)?.general_order_cutoff_time;
          // this.special_order_cutoff_days = this.appService.appObject.selectedRestaurantDetails?.general_order_cutoff_day;
        }

        this.availableSubscriptionDays = JSON.parse(this.appService.appObject.selectedRestaurantDetails?.subscription_order_cutoff_time)?.available_days;
        this.availableSpecialDays = JSON.parse(this.appService.appObject.selectedRestaurantDetails?.general_order_cutoff_time)?.general_order_available_days;

        // this.setSpecialMinDate();

        // if postal code mode is off, get address details from myAddress object
        if (this.appService.appObject.settings.is_postalcode_mode !== 'true') {
          this.addressForm.address = this.appService.appObject.myAddress.name;
          this.addressForm.backyard = this.appService.appObject.myAddress.backyard ? this.appService.appObject.myAddress.backyard : '';
          this.addressForm.lat = this.appService.appObject.myAddress.lat;
          this.addressForm.lng = this.appService.appObject.myAddress.lng;
          this.addressForm.street_number = this.appService.appObject.myAddress.streetNo;
        }

        // init street google input after initializing the data in checkout page
        setTimeout(() => {
          // waiting to get street address input to initialize,
          // sometimes street address input won't show till user going to edit an address
          // so keep trying to initialize the input, once initiated intervel will be clear
          let streetInputInitInt = setInterval(() => {
            if (!this.streetAddressGoogleInputInitialized && this.googleaddressbackary && !this.appService.disableGoogleAutoComplete) {
              this.appService.initGoogleBakery(this.googleaddressbackary.nativeElement);
              this.appService.appObject.isLoading = false;
              this.watchStreetInputUpdates();

              this.streetAddressGoogleInputInitialized = true;
              clearInterval(streetInputInitInt);
            }
          }, 1500);
        }, 2000);

        // get default payment method
        let defaultPaymentMethod = this.appService.appObject.selectedRestaurantDetails.payment_methods.find((method) => method.id === this.appService.appObject.selectedRestaurantDetails.default_payment_method);
        // check if the selected default payment method is available for selected ordering type
        // if not no payment method will be selected
        if (defaultPaymentMethod && defaultPaymentMethod['is_' + this.appService.appObject.selectedDeliveryMethod] === 'true') {
          let availableList = this.getAvailablePaymentOptions();

          if (availableList.find((method) => method.id === defaultPaymentMethod.id)) {
            this.selectedPaymanetMethod = this.appService.appObject.selectedRestaurantDetails.default_payment_method;
            this.selectedPaymanetMethodObject = defaultPaymentMethod;
            this.appService.appObject.orderObject.selectedPaymentMethod = this.selectedPaymanetMethod;
            
            this.appService.calculateCartAmountsV2();
            
          }
        }

        // With UBER Direct we re not gonna allow COD method. So if the default payment option is COD then removes it ans make selected payment method unselected
        if(this.appService.appObject.selectedDeliveryMethod === 'delivery' && this.appService.appObject.selectedRestaurantDetails && this.appService.appObject.selectedRestaurantDetails.delivery_via_uber === 'true'){
          if(this.selectedPaymanetMethod === 'cod'){
            this.appService.appObject.orderObject.selectedPaymentMethod =null;
            this.selectedPaymanetMethodObject = null;
            this.selectedPaymanetMethod = '';
          }
          // console.log('selectedPaymanetMethod: ' , this.selectedPaymanetMethod);
        }
        
      }

      this.appService.appObject.orderObject.tip_amount = 0;
      this.appService.appObject.orderObject.is_tip_recurring = false;
      this.isTipRecurring = false;

      // fetch tips related configurations of selected restaurant
      if (this.appService.appObject.selectedRestaurantDetails && this.appService.appObject.selectedRestaurantDetails.tips_configuration) {
        let tipsConfig = this.appService.appObject.selectedRestaurantDetails.tips_configuration;
        
        this.allowCustomTipAmounts = tipsConfig.allow_custom_amounts === 'true';
        this.isTipsEnabled = tipsConfig.status === 'true';
        this.tipsMessage = tipsConfig.tips_message ? tipsConfig.tips_message : '';
        this.predefinedTipAmounts = tipsConfig.predefined_tip_amounts ? tipsConfig.predefined_tip_amounts : [];
      }

      //check restaurant is closed
      if(this.appService?.closenotice && !this.appService.isPreOrderAccept){

        if(this.isGenaralOrderModeEnabled){
          this.isGenaralOrderModeEnabled = false;
        }
          //change default if general mode is a default
          if(!(this.isSubscriptionOrderModeEnabled && this.isGenaralSpecialOrderModeEnabled)){
            if(!this.is_subscription_order && this.isSubscriptionOrderModeEnabled){ 
              this.is_subscription_order = true;
              this.allowOnlySubscriptionMode = true;
              console.log('hhhhhhhhh')
            } 
          } 
          if(!this.isGenaralSpecialOrderModeEnabled){
            this.allowOnlySubscriptionMode = true;
          } 
      }

      // make subscription order mode check box disabled when only subscription mode enabled
      if(this.isSubscriptionOrderModeEnabled && !this.isGenaralSpecialOrderModeEnabled && !this.isGenaralOrderModeEnabled){
        this.allowOnlySubscriptionMode = true;
      }

    }, 1000);


    this.appService.onCartCalculation.subscribe((response) => {
      this.calculatePointsAmounts();
    });
  }

  /**
   * Will trigger when user input on street input field when disableGoogleAutoComplete is on
   */
  addressChangeOnCustomStreetInputMode() {

    // This function should only called when google auto complete is disabled and delivery via driver app is on
    if (this.appService.disableGoogleAutoComplete && this.appService.appObject.selectedRestaurantDetails.is_manage_delivery_via_driver_app === 'true' && this.appService.appObject.settings.is_postalcode_mode === 'true') {

      console.log('street: ', this.addressForm);

      // Clear the existing timeout (if any)
      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
      }

      this.debounceTimeout = setTimeout(async () => {

        const { city, street, postal_code, street_number } = this.addressForm;

        // reset geo coordinates
        this.addressForm.lat = null;
        this.addressForm.lng = null;

        // Check if all values exist and are non-empty
        if (
          city?.trim() &&
          street?.trim() &&
          postal_code?.trim() &&
          street_number?.trim()
        ) {
          const fullAddress = `${street} ${street_number}, ${postal_code} ${city}`;

          console.log('fullAddress: ', fullAddress);


          // check if the key is available or not
          if (!config.gkey) {
            // if not available request the key from backend
            await this.appService.getGoogleKey();

            // still not found the key, then return false
            if (!config.gkey) return false;
          }

          const apiKey = config.gkey;

          const response = await fetch('https://places.googleapis.com/v1/places:searchText', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Goog-Api-Key': apiKey,
              'X-Goog-FieldMask': 'places.location,places.displayName',
            },
            body: JSON.stringify({
              textQuery: fullAddress,
              languageCode: 'en',
              regionCode: 'DE', // Optional: prioritizes results in Germany
            }),
          });

          const data = await response.json();

          if (data.places && data.places.length > 0) {
            const place = data.places[0];
            const { latitude, longitude } = place.location;
            console.log(`Latitude: ${latitude}, Longitude: ${longitude}`);
            this.addressForm.lat = latitude;
            this.addressForm.lng = longitude;
          } else {
            console.error('No results found for the given address');
          }
        } else {
          console.warn('Cannot fetch geolocation: missing required address fields.');
        }

      }, 400);

    }
  }

  ionViewWillEnter() {
    this.appService.hideCartButton = false;
    // this will make the floating cart button to display top right corner of the display instead of bottom right
    this.appService.className2 = ' cart-top';

    this.updateFormData();
  }

  ionViewWillLeave() {
    this.appService.hideCartButton = true;
    this.appService.className2 = ' ';
  }

  selectedTimeRadioValue: any = ''; // Initialize with an empty string

  radioTimeValueChanged(value: any) {
    this.selectedTimeRadioValue = value;
  }

  /**
   * Will trigger when user select an address from the address book
   * @param address selected address book object
   */
  async onAddressChangeFromTheBook(address: any) {
    // console.log('address : ' , address);

    // if postal code mode is enabled only takes necessory data from the address book object
    if (this.appService.appObject.settings.is_postalcode === 'true') {

      if (this.appService.appObject.selectedRestaurantDetails && this.appService.appObject.selectedRestaurantDetails.postal_code_details) {
        let postalCodeDetails = this.appService.appObject.selectedRestaurantDetails.postal_code_details;
        // console.log('address : ' , address);

        let postalCodeFound = postalCodeDetails.find((postalCode) => postalCode.code === address.postal_code);
        // if the restaurant is support for selected postal area
        if (postalCodeFound) {
          this.selectedAddressDetailsFromTheBook = address;
          this.appService.appObject.addressBookObject = { ...address };

          this.addressForm.name = address.name;
          this.addressForm.address = address.address;
          this.appService.appObject.myAddress.lat = this.addressForm.lat = address.latitude;
          this.appService.appObject.myAddress.lng = this.addressForm.lng = address.longitude;
          this.addressForm.mobile_number = address.mobile_number;
          this.addressForm.postal_code = address.postal_code;
          this.addressForm.street = address.street;
          this.addressForm.street_number = address.house_number;
          this.addressForm.city = address.city;
          this.addressForm.backyard = address.backyard;

          // console.log('address form : ' , this.addressForm);
          this.appService.appObject.addressObjectForPostalCode = address;

          // there is modification needed to postal code object pricing to do calculations in appService calculate cart amount function
          let copyOfPostalSelected = { ...postalCodeFound };
          if (!copyOfPostalSelected.price) {
            copyOfPostalSelected.price = [{ restaurantId: this.appService.appObject.selectedRestaurantDetails.id, cost: copyOfPostalSelected.cost, minOrderAmount: copyOfPostalSelected.min_order }];
          } else {
            let found = copyOfPostalSelected.price.find((pric) => pric.restaurantId === this.appService.appObject.selectedRestaurantDetails.id);
            found = { restaurantId: this.appService.appObject.selectedRestaurantDetails.id, cost: copyOfPostalSelected.cost, minOrderAmount: copyOfPostalSelected.min_order };
          }

          this.appService.appObject.postalCodeDetails = copyOfPostalSelected;
          this.postalCodeDetails = copyOfPostalSelected;

          this.appService.calculateCartAmounts();

          this.addressSelectActionTriggered = true;
        } else {
          this.appService.showToast('Selected restaurant not delivering to the selected area', 'danger');
        }
      }
    } else {
      // console.log('address :', address);
      let restaurantsList: any = await this.appService.getRestaurantsInGivenLocation({ lat: address.latitude, lng: address.longitude });
      if (restaurantsList.status && restaurantsList.data) {
        let found = restaurantsList.data.find((restaurant) => restaurant.id === this.appService.appObject.selectedRestaurantDetails.id);
        if (found) {
          // console.log('found: ' , found);

          this.appService.appObject.myAddress.name = address.address;
          this.currentlySelectedAddress = address.address;
          this.appService.appObject.myAddress.lat = address.latitude;
          this.appService.appObject.myAddress.lng = address.longitude;

          this.addressForm.address = address.address;
          this.addressForm.lat = address.latitude;
          this.addressForm.lng = address.longitude;
          this.addressForm.street_number = address.house_number;
          this.addressForm.backyard = address.backyard;
          this.addressForm.city = address.city;
          this.addressForm.postal_code = address.postal_code;

          if(address.uber_address){
            // find out the state
            let splittedUberAddress = address.uber_address.split(',');
            let state = '';
            if(splittedUberAddress.length >= 3){
              // last element contains the state value
              let splitLastElement = splittedUberAddress[2].trim().split(' ');
              if(splitLastElement.length >= 2){
                state = splitLastElement[0].trim();
              }
            }

            this.appService.appObject.uberAddressDetailsObject = {
              isValid: state ? true : false,
              addressDetailedObject: {
                streetNumber: address.house_number,
                street: address.street,
                postalCode: address.postal_code,
                city: address.city,
                state: state,
              },
              formattedAddress: address.uber_address
            }

            await this.appService.updateAppObject();
          }

          // get restaurant details again to calculate distance and delivery cost for changed address 
          await this.appService.getRestaurantBySlug(found.slug);
        } else {
          this.appService.showToast('Selected restaurant not delivering to the selected address', 'danger');
        }
      } else {
        this.appService.showToast('Selected restaurant not delivering to the selected address', 'danger');
      }
      this.addressSelectActionTriggered = true;
    }

    // when user select an address from the list, editable option will be disabled 
    this.addressEditable = false;
  }

  async openModal(content: TemplateRef<any>, isSelectPayment = false) {
    const modal = await this.modalCtrl.create({
      component: InputSelectModalComponent,
      cssClass: 'select-modal',
      componentProps: {
        isSelectPayment : isSelectPayment,
        content: content, // Pass the content as a TemplateRef
      },
    });
    // hide cart button when popup opening
    this.appService.hideCartButton = true;

    modal.present();
    this.paymentModal = modal;
    const { data, role } = await modal.onWillDismiss();
    // make cart icon visible when popup close
    this.appService.hideCartButton = false;
  }

  saveAddressChanges() {
    if (this.verifyAddressComponents()) {
      this.addressEditable = false;
    }
  }


  focusToErrors() {


    let element = null;

    element = document.getElementsByClassName('field-error');

    if (element.length > 0) {
      let firstElement = element[0];
      firstElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return true;
    }


    return false;



  }


  isElementHidden(element) {
    // Check if the element itself is hidden
    if (element.style.display === 'none' || element.style.visibility === 'hidden' || getComputedStyle(element).display === 'none') {
      return true;
    }

    // Check if any of the element's parents are hidden
    let parent = element.parentElement;
    while (parent) {
      if (parent.style.display === 'none' || parent.style.visibility === 'hidden' || getComputedStyle(parent).display === 'none') {
        return true;
      }
      parent = parent.parentElement;
    }

    // If none of the element or its parents are hidden, the element is visible
    return false;
  }


  verifyAddressComponents(doNotFocus: boolean = false) {
    this.addressFormValidator = {};

    if (this.addressForm.name && this.addressForm.name.trim()) {
      let splittedName = this.addressForm.name.split(' ');
      if (splittedName.length === 1) { this.addressFormValidator['name'] = 'key.both_first_and_last_names_are_required'; }
    } else { this.addressFormValidator['name'] = 'key.name_is_required'; }

    if (!this.addressForm.mobile_number || !this.addressForm.mobile_number.trim()) {
      this.addressFormValidator['mobile_number'] = 'key.mobile_number_is_required';
    }

    if (!this.addressForm.email || !this.addressForm.email.trim()) {
      this.addressFormValidator['email'] = 'key.email_is_required';
    }

    // check if the custom street input mode is disabled
    if(!this.appService.disableGoogleAutoComplete){
      if (this.appService.appObject.settings.is_postalcode === 'true' && (!this.addressForm.street || !this.addressForm.street.trim())) {
        this.addressFormValidator['street'] = 'key.street_is_required';
      }

      if (!this.addressForm.lat || !this.addressForm.lng) {
        this.addressFormValidator['street'] = 'key.please_select_a_valid_street_address';
      }
    }

    if (!this.addressForm.street_number) {
      this.addressFormValidator['street_number'] = 'key.street_number_must_have_a_value';
    }



    // check any errors available in validator object
    if (Object.getOwnPropertyNames(this.addressFormValidator).length) {
      this.addressEditable = true;

      // auto focuse to the inputs with errors
      if (!doNotFocus) {
        setTimeout(() => {
          let errorProps = Object.getOwnPropertyNames(this.addressFormValidator);
          if (errorProps.includes('name')) {
            let ele = document.getElementById('address-name');

            console.log('name error');

            if (ele) ele.focus()
          } else if (errorProps.includes('mobile_number')) {
            let ele = document.getElementById('address-mobile-number');
            if (ele) ele.focus()
          } else if (errorProps.includes('email')) {
            let ele = document.getElementById('address-email');
            if (ele) ele.focus()
          } else if (errorProps.includes('street')) {
            let ele = document.getElementById('postal-code-google');
            if (ele) ele.focus()
          }
        }, 200);
      }
      return false;
    }

    return true;
  }

  /**
   * Initialize each time street input visible
   */
  initGoogleInput() {
    setTimeout(() => {
      if (this.googleaddressbackary) {
        this.appService.initGoogleBakery(this.googleaddressbackary.nativeElement);
        this.watchStreetInputUpdates();
      }
    }, 200);
  }

  /**
   * Watch for updates in street input (when postal code is on)
   */
  watchStreetInputUpdates() {
    this.appService.onStreetGoogleInputUpdate.subscribe((data) => {
      this.addressForm.street = data.street;
      this.addressForm.lat = data.lat;
      this.addressForm.lng = data.lon;
      this.addressForm.street_number = data.streetNo;

      // clear form errors
      if (this.addressForm.street) this.addressFormValidator['street'] = '';
      if (this.addressForm.street_number) this.addressFormValidator['street_number'] = '';

      // genarate an address with current details and assign to my address object
      this.addressForm.address = data.street + ' ' + data.streetNo + ',' + this.postalCodeDetails.name + ' ' + this.postalCodeDetails.code;

      this.haveValidAddressDataFromGoogle = true;
    })
  }


  /**
   * Get current user details to auto fill necessory data
   */
  getUserDetails() {
    this.userPoints = null;
    this.userDetailsLoading = true;

    this.appService.getUserDetails({ 'customer_id': this.appService.appObject.userId }).then((data: any) => {
      if (data.status) {
        this.appService.appObject.user.fname = data.data.first_name;
        this.appService.appObject.user.lname = data.data.last_name;
        this.appService.appObject.user.email = data.data.email;
        this.appService.appObject.user.company = data.data.company;
        this.appService.appObject.user.telephone = data.data.mobile_number;
        this.updateFormData();

        // get user's reward points 
        if (data.data.points && data.data.points.length) {
          let userPoints = data.data.points;
          // Object.keys(userPoints).map((key) => {
          //   // get the usable points for selected restaurant
          //   if (key === (this.appService.appObject.selectedRestaurantId + '')) {
          //     // remove decimals 
          //     userPoints[key].points = userPoints[key].points ? userPoints[key].points.toFixed(0) : userPoints[key].points;
          //     this.userPoints = userPoints[key];
          //   }
          // });
          this.userPoints = userPoints.find((pointsOb) => pointsOb.restaurant_id === this.appService.appObject.selectedRestaurantId);

          this.calculatePointsAmounts(true);
        }

        // if there is no points details,
        // assign default values so can do calculations without any issue
        if(!this.userPoints){
          this.userPoints = {
            points:0,
            value: 0
          }
          this.calculatePointsAmounts(true);
        }

        // get user address book data
        if (data.data.addressBook) this.userAddressesList = data.data.addressBook;
        else this.userAddressesList = [];

        // filter out addresses with uber address in address book data if the selected restaurant is de=livering via UBER Direct
        if(this.appService.appObject.selectedRestaurantDetails.delivery_via_uber === 'true'){
          this.userAddressesList = this.userAddressesList.filter((address) => address.uber_address);
        }

        this.postalCodeAddress = this.userAddressesList.filter((addressC) => addressC.is_postalcode_mode === 'true' && addressC.latitude && addressC.longitude);
        this.normalAddress = this.userAddressesList.filter((addressC) => addressC.is_postalcode_mode !== 'true');

        // Filterout if google auto complete is disabled, Then only get addresses that are on postal code mode and lat and long are null
        if(this.appService.disableGoogleAutoComplete){
          this.postalCodeAddress = this.userAddressesList.filter((addressC) => addressC.is_postalcode_mode === 'true' && !addressC.latitude && !addressC.longitude);
        }

        // take most recent address from the address book data and assign as currently selected address
        let defaultAddressSelected = false;
        if (this.appService.appObject.settings.is_postalcode === 'true' && this.postalCodeAddress.length) {

          let selectedPostalCodeAreaAddresses = this.postalCodeAddress.filter((postalCodeD) => postalCodeD.postal_code === this.postalCodeDetails.code);
          // in postal code mode, default address is selecting with selected postal code area
          // if there is no addresses for selected postal area, then no address will automatically selected
          // instead make address editable 
          if (selectedPostalCodeAreaAddresses.length) {
            this.selectedAddressDetailsFromTheBook = selectedPostalCodeAreaAddresses[selectedPostalCodeAreaAddresses.length - 1];
            defaultAddressSelected = true;
          } else {
            this.addressEditable = true;
          }

        } else if (this.normalAddress.length) {
          // do not select default address when postal code is off
          // this.selectedAddressDetailsFromTheBook = this.normalAddress[this.normalAddress.length - 1];
          // defaultAddressSelected = true;
        }
        // if default address selected from the addressbook, then update the address form data with selected data
        if (defaultAddressSelected) {

          this.addressForm.address = this.selectedAddressDetailsFromTheBook.address;
          this.addressForm.city = this.selectedAddressDetailsFromTheBook.city;
          this.addressForm.mobile_number = this.selectedAddressDetailsFromTheBook.mobile_number;
          this.addressForm.name = this.selectedAddressDetailsFromTheBook.name;
          this.addressForm.postal_code = this.selectedAddressDetailsFromTheBook.postal_code;
          this.addressForm.street_number = this.selectedAddressDetailsFromTheBook.house_number;
          this.addressForm.street = this.selectedAddressDetailsFromTheBook.street;
          this.addressForm.backyard = this.selectedAddressDetailsFromTheBook.backyard;
          this.addressForm.lat = this.selectedAddressDetailsFromTheBook.latitude;
          this.addressForm.lng = this.selectedAddressDetailsFromTheBook.longitude;

          this.addressEditable = false;
          this.appService.appObject.addressObjectForPostalCode = this.selectedAddressDetailsFromTheBook;
          this.appService.appObject.addressBookObject = { ...this.selectedAddressDetailsFromTheBook };

          // set company name
          if(this.appService.appObject.displayCompanyInput) this.addressForm.company = this.appService.appObject.user.company ? this.appService.appObject.user.company : null;
        }
      }
    }).finally(() => this.userDetailsLoading = false);
  }

  /**
   * Calculate points amounts to pay in points
   * moved to separate function to call from diffrent locations
   */
  async calculatePointsAmounts(isOnInit = false) {
    // points system related
    let restaurantPaymentMethods = this.appService.appObject.selectedRestaurantDetails.payment_methods;
    let pointsEnabled = restaurantPaymentMethods.find((method) => method.id === 'points' && method.isActive === 'true');
    if (this.userPoints && pointsEnabled && pointsEnabled.config && this.appService.appObject.orderObject.cart_summery && this.appService.appObject.orderObject.cart_summery.gross_total) {
      this.pointConfig = pointsEnabled.config;
      let grossTotal = this.appService.appObject.orderObject.cart_summery.gross_total;
      // console.log('pointConfig : ' , this.pointConfig);
      // console.log('user points : ' , this.userPoints);

      if(isOnInit && this.pointConfig && this.pointConfig.force_to_recharge === 'true' && this.userPoints && !this.userPoints.points){ //  && this.userPoints && !this.userPoints.points
        let enabledMethodOtherThanPoints = restaurantPaymentMethods.find((method) => method.id !== 'points' && method.isActive === 'true');
        if(!enabledMethodOtherThanPoints){
          this.openPointRechargeModal();
        }else{
          this.confirmPopup();
        }
      }
      

      // let pointValue = (+this.pointConfig.valueInPoints) / (+this.pointConfig.valueInCurrency);
      let totalPointRequirement = grossTotal * (+this.pointConfig.valueInPoints);
      // console.log('totalPointRequirement : ' , totalPointRequirement);

      this.isOrderAmountPointsReached = (this.userPoints.points >= totalPointRequirement) ? true : false;

      // check the minimum point amount reached
      this.isMinimumPointsAmountReached = (totalPointRequirement >= (+this.pointConfig.minPoints)) ? true : false;

      this.totalPointRequirement = totalPointRequirement.toFixed(2);
      // console.log('this.isOrderAmountPointsReached : ' , this.isOrderAmountPointsReached , ' | totalPointRequirement : ' , totalPointRequirement, ' | ',this.userPoints.points);
    }
  }

  /**
   * update address basic details from user detils
   */
  async updateFormData() {

    //concat only if lname is not empty or not undefined
    if(this.appService.appObject.user.lname){
      this.addressForm.name = this.appService.appObject.user.fname + ' ' + this.appService.appObject.user.lname;
    }else{
      this.addressForm.name = this.appService.appObject.user.fname;
    }
    this.addressForm.email = this.appService.appObject.user.email;
    this.addressForm.mobile_number = this.appService.appObject.user.telephone;
    if(this.appService.appObject.displayCompanyInput) this.addressForm.company = this.appService.appObject.user.company;

    // if the postal code mode is on, then get previous order details from appObject
    // if (this.appService.appObject.settings.is_postalcode === 'true' && this.appService.appObject.postalCodeExtraDetails) {
    //   this.addressForm.address = this.appService.appObject.postalCodeExtraDetails.address;
    //   this.addressForm.street_number = this.appService.appObject.postalCodeExtraDetails.streetNumber;
    //   this.addressForm.street = this.appService.appObject.postalCodeExtraDetails.street;
    //   this.addressForm.lat = this.appService.appObject.postalCodeExtraDetails.lat;
    //   this.addressForm.lng = this.appService.appObject.postalCodeExtraDetails.lng;
    // }

    // if user has no previous address data, then make form editable
    if (!this.postalCodeAddress.length && !this.normalAddress.length && !this.appService.appObject.myAddress.name) {
      this.addressEditable = true;
    }

     // if user has no previous address data, then make form editable
     if (this.validateIsRequrefileds()) {
      this.addressEditable = false;
      console.log('address is not editable');
    }else{
      console.log('address is editable');
      this.addressEditable = true;
    }


    // If the user is in guest mode and has ordered before, what below do is to try to auto refill previous order delivery details 
    // if available in local storage
    if(this.appService.appObject.selectedDeliveryMethod === 'delivery' && this.appService.appObject.settings.is_postalcode === 'true' && !this.appService.appObject.isAuthed){
      let lastGuestPostalAddress:any[] = await this.appService.getLastPostalCodeAddressAsGuestUser();

      // find out if any previous guest order address available for selected restaurant
      let previousGuestAddress = lastGuestPostalAddress.find((addresses) => addresses.restaurants_id === this.appService.appObject.selectedRestaurantId);
      
      if(previousGuestAddress){
        this.addressForm.street_number = previousGuestAddress.street_number;
        this.addressForm.street = previousGuestAddress.street;
        this.addressForm.name = previousGuestAddress.name;
        this.appService.appObject.myAddress.lat = this.addressForm.lat = previousGuestAddress.latitude;
        this.appService.appObject.myAddress.lng = this.addressForm.lng = previousGuestAddress.longitude;
        this.addressForm.company = previousGuestAddress.company;
        this.addressForm.backyard = previousGuestAddress.backyard;
        this.addressForm.address = previousGuestAddress.address??'';
        this.addressForm.email = previousGuestAddress.email??'';
        this.addressForm.mobile_number = previousGuestAddress.mobile_number??'';

        // if above data is filled, then no need to make delivery details editable by default
        this.addressEditable = false;
      }
    }
  }

  validateIsRequrefileds(){
    if(this.appService.appObject.selectedDeliveryMethod === 'delivery'){
      if(this.addressForm.name.length && this.addressForm.email.length && this.addressForm.mobile_number.length && this.appService.appObject.myAddress.name){
        return true;
      }
      return false;
    }else{
      if(this.addressForm.name.length && this.addressForm.email.length && this.addressForm.mobile_number.length){
        return true;
      }
      return false;
    }
    
  }

  /**
 * get available delivery times
 */
  async getDeliveryTimes() {
    this.appService.getOpenTimes().then(data => {
      if (data.status) {
        // console.log(data.data);
        this.deleveryAvailableTimes = data.data;
        this.todayDate = data.today;
        this.maxDate = data.maxDate;


        Object.keys(data.data).forEach(key => {
          this.deliveryDates.push(key);
          if (key === this.todayDate) {
            // console.log('selecting', key);
            this.selectedDate = this.todayDate;

          }
        });

        setTimeout(async () => {
          // call get days function to trigger (ionChange) event manually in delivery_date select list,
          // otherwise it won't call because of ngIf condition in select list
          this.selectedDeliveryDateValue = this.selectedDate;

          this.getDays({ detail: { value: this.selectedDate } });

          // below function call moved from the bottom preOrderAvailability check section
          let openTimesConfigurations = this.appService.findSelectedRestaurantOrderTypesV2(this.appService.appObject.selectedRestaurantDetails, true);
          
          // if currently available methods not available but future available methods are there, means it's preorder time
          this.isPreOrderOnly = !openTimesConfigurations.currentlyAvailableDeliveryMethods.length && openTimesConfigurations.futureAvailableMethods.length > 0;
          // then check if the restaurant is currently in lunchbreak (in between same day two time slots), if it is still means it's only available preorders
          // so no ASAP option
          if(!this.isPreOrderOnly && this.appService.isClosedBetweenTwoTimeSlots){
            this.isPreOrderOnly = true;
          }
          // if the current time is early before even open the restaurant, still it's preorder time, so no ASAP option
          if(openTimesConfigurations.restaurantStillClosed){
            this.isPreOrderOnly = true;
          }

          if (this.selectedDate == this.todayDate && !this.isPreOrderOnly) {
            // check if the selected ordering option is available only for preorder,
            // if it is, then do not display asap option
            let preOrderAvailability = openTimesConfigurations.preorderOptions;
            let onlyAvailableForPreorder = preOrderAvailability && preOrderAvailability[this.appService.appObject.selectedDeliveryMethod] ? true : false;

            if (!onlyAvailableForPreorder) {
              this.displayAsapOption = true;
              this.selectedDeliveryTimeValue = 'asap';

              // clear selected time slot when set the asap value
              this.appService.appObject.selectedTimeSlot = '';
              await this.appService.updateAppObject();
              await this.appService.calculateCartAmountsV2();

              // notify user that the delivery cost has been changed
              if(this.initialDeliveryCost !== this.appService.appObject.orderObject.cart_summery.delivery_cost){
                this.translate.get('key.delivery_cost_changed').subscribe((lang) =>{
                  this.appService.showToast(lang,'secondary','middle',3000,'delivery-cost-changed-toast');
                });
              }

              setTimeout(() => {
                this.initialDeliveryCost = this.appService.appObject.orderObject.cart_summery.delivery_cost;
              }, 500);
            }
          } else if (this.selectedDate == this.todayDate && this.appService.appObject.selectedRestaurantDetails?.openDetails?.is_pre_order) {
            // set first value as default value
            if (this.selectedTimes.length) this.selectedDeliveryTimeValue = this.selectedTimes[0];
          }
          this.selectedTimesLoading = false;

          // check if there are unavailable dishes in cart with default order times
          this.onTimeChangeOrCartChange();
        }, 1000);



      } else {
        this.selectedTimesLoading = false;
      }
    }, error => {
      this.appService.appObject.isLoading = false;
      this.selectedTimesLoading = false;
    });
  }


  /**
   * Will return selected day available times
   * @param e selected date
   */
  async getDays(e) {
    if (/^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$/.test(e.detail.value)) {
      this.selectedTimes = this.deleveryAvailableTimes[e.detail.value];
      this.selectedDate = e.detail.value;
    } else {
      this.selectedTimes = this.deleveryAvailableTimes[this.todayDate];
      this.selectedDate = this.todayDate;
    }
    this.selectedDeliveryTimeValue = '';
  }

  /**
 * Check dish availability when time change or cart item change
 * @returns 
 */
  onTimeChangeOrCartChange() {
    this.showMenuCategoriesNotAvailableError = false;
    if (this.checkMenuCategoriesAvailability()) {
      this.showMenuCategoriesNotAvailableError = true;
    }
  }

  /**
 * Will check selected dishes menu categories are available or not at the selected order date and time
 * @returns nothing
 */
  checkMenuCategoriesAvailability() {
    let unavailableMenus = [];
    let unavalableDishes = [];

    this.unavailableMenus = [];
    this.appService.unavailableDishes = [];

    if (!this.is_subscription_order && this.selectedDeliveryTimeValue && this.selectedDeliveryDateValue && this.appService.appObject.orderObject && this.appService.appObject.orderObject.cart) {
      let orderDate = this.selectedDeliveryDateValue;
      let orderTime = this.selectedDeliveryTimeValue;
      // get user selected date name, ex : MON / TUE
      const orderDay = this.daysOfWeek[new Date(orderDate).getDay()];

      // If the user has selected order time as ASAP, then get current time in HH:MM format as orderTime
      if (orderTime == 'asap') {
        let currentTime = new Date();
        orderTime = currentTime.getHours().toString().padStart(2, '0') + ':' + currentTime.getMinutes().toString().padStart(2, '0');
      }

      // get all the cart items that user has selected
      let cartItems = this.appService.appObject.orderObject.cart;
      for (let i = 0; i < cartItems.length; i++) {
        const dish = cartItems[i];
        // findout the menu category of the dish
        let menuCategory = this.appService.menuList.find((menu) => menu.id === dish.menu_category_id);

        if (menuCategory && menuCategory.visibility) {
          let visibility = JSON.parse(menuCategory.visibility);
          let orderVisibility = visibility.find((day) => day.day === orderDay);
          // console.log('orderVisibility : ', orderVisibility);

          let notAvailable = false;


          if (!orderVisibility.isActive) {
            notAvailable = true;
          } else if (orderVisibility.timeSlot && orderVisibility.timeSlot.from === 'All Day') { // If the category is available whole day, then ignore it
            // return;
          } else {
            let currentDate = this.appService.formatDateObject(new Date(), false);
            let visibilityFrom = new Date(currentDate + ' ' + orderVisibility.timeSlot.from);
            let visibilityTo = new Date(currentDate + ' ' + orderVisibility.timeSlot.to);
            let orderTimeAsDate = new Date(currentDate + ' ' + orderTime);

            if (visibilityFrom.getTime() > orderTimeAsDate.getTime()) { // if the available time not reached yet
              // console.log('Not Available Yet');
              notAvailable = true;
            } else if (visibilityTo.getTime() < orderTimeAsDate.getTime()) { // if the available time has passed
              // console.log('Available Time Passed');
              notAvailable = true;
            } else {
              // console.log('Available to Order');
            }
          }

          if (notAvailable) {
            unavalableDishes.push(dish)

            let exists = unavailableMenus.find((item) => item.menu_id === menuCategory.id)
            if (!exists) {
              unavailableMenus.push({
                menu_id: menuCategory.id,
                name: menuCategory.name,
                availableAt: {
                  from: !orderVisibility.isActive ? ' - ' : orderVisibility.timeSlot.from,
                  to: !orderVisibility.isActive ? '' : orderVisibility.timeSlot.to
                }
              })
            }
          }
        }
      }
    } else if (this.is_subscription_order) {
      // get all the cart items that user has selected
      let cartItems = this.appService.appObject.orderObject.cart;
      for (let i = 0; i < cartItems.length; i++) {
        const dish = cartItems[i];
        // findout the menu category of the dish
        let menuCategory = this.appService.menuList.find((menu) => menu.id === dish.menu_category_id);

        if (menuCategory && menuCategory.visibility) {
          let visibility = JSON.parse(menuCategory.visibility);

          let notAvailable = [];

          // if (this.checkoutForm.value.order_schedule_type === 'daily') {
          //   notAvailable = visibility.filter((dayData) => !dayData.isActive);
          // } else 
          if (this.order_schedule_type === 'weekly' && this.selectedSubscribtionDates) {
            // check selected menu categories availability for selected week days 
            notAvailable = visibility.filter((dayData) => this.selectedSubscribtionDates.includes((dayData.day + '').toUpperCase()) && !dayData.isActive);
          }

          // console.log(menuCategory.name , ' | Visibility : ' , visibility);
          if (notAvailable.length) {
            unavalableDishes.push(dish)

            let exists = unavailableMenus.find((item) => item.menu_id === menuCategory.id)
            if (!exists) {
              unavailableMenus.push({
                menu_id: menuCategory.id,
                name: menuCategory.name,
                availability: visibility
              })
            }
          }
        }
      }
    }

    // console.log('unavalable menus : ', unavailableMenus);
    this.unavailableMenus = unavailableMenus;
    this.appService.unavailableDishes = unavalableDishes;
    return this.unavailableMenus.length;
  }

  /**
 * open cart pop up to show dishes that not available for order date and time
 */
  async openCartPopup() {
    if (!this.appService.isWebVersion) {
      this.appService.hideCartButton = true;

      const cartModal = await this.modalCtrl.create({
        component: CartPage,
        cssClass: 'custom-popup',
        componentProps: { highlightUnavailableDishes: true }
      });

      await cartModal.present();

      cartModal.onDidDismiss().then((data) => {
        this.appService.hideCartButton = false;
        this.onTimeChangeOrCartChange();
      });
    }
  }

  async placeOrder() {
    // display date is empty error
    this.dateCannotBeEmpty = false;
    //focus to errors if exists 
    if (!this.focusToErrors()) {
      //set a interval to check weather check errors appears later.
      const intervalId = setInterval(() => {
        const shouldStop = this.focusToErrors();
        if (shouldStop) {
          clearInterval(intervalId); // stop interval if return true;
        }
      }, 1000);
    }

    // do these validations if this is not a delivery order
    if (this.appService.appObject.selectedDeliveryMethod !== 'delivery') {
      if (this.addressForm.name && this.addressForm.name.trim()) {
        let splittedName = this.addressForm.name.split(' ');
        if (splittedName.length === 1) { this.addressFormValidator['name'] = 'key.both_first_and_last_names_are_required'; return; }
      } else { this.addressFormValidator['name'] = 'key.name_is_required'; return; }

      if (!this.addressForm.mobile_number || !this.addressForm.mobile_number.trim()) {
        this.addressFormValidator['mobile_number'] = 'key.mobile_number_is_required';
        return;
      }

      if (!this.addressForm.email || !this.addressForm.email.trim()) {
        this.addressFormValidator['email'] = 'key.email_is_required';
        return;
      }

      if (this.appService.appObject.orderObject && this.appService.appObject.orderObject.cart_summery && !this.appService.appObject.orderObject.cart_summery.min_reached) {
        this.appService.showToast('Minimum Order Amount Not Reached', 'danger');
        return;
      }
    }

    // if is subscription mode is on, check if there is coupon added and it's available for subscription orders
    if(this.is_subscription_order && this.confirm_Popup_Coupon_Not_Supported(true)) {
      console.log('Coupon Not Supported');
      return;
    }

    // check selected ordering type is available or not in the selected restaurant
    if(!this.appService.appObject.selectedDeliveryMethod){
      this.translate.get('key.please_select_an_ordering_method_first').subscribe((data) =>{
        this.appService.showToast(data, 'danger');
      });
      return; 
    }

    // <---------------- Verification START ----------------->
    let verificationFail = false;

    if (this.appService.appObject.userVerificationRequired && !this.appService.appObject.user.is_verified) {

      this.verificationInProgress = true;

      let verificatioData = { mobile_number: this.appService.appObject.user.telephone, email: this.appService.appObject.user.email };
      // request verification code, will check in backend for the method mobile / email and send back the method
      await this.appService.requestVerificationCode(verificatioData).then(async (verificationResponse) => {
        // if verification code has been sent, will return the what method used to sent 
        if (verificationResponse.status) {
          this.appService.startVerificationCodeIntervalCountdown();

          let otpVerificationPopup = null;
          if (this.appService.isWebVersion) {
            verificationResponse.operationType = 'registration';
            this.otpCodeResponse = verificationResponse;
            this.otpCodeResponse.userData = verificatioData;
            this.otpCodeResponse.operationType = 'checkout-verification';
            // this.onVerificationCodeSent.emit(verificationResponse);

            otpVerificationPopup = await this.modalCtrl.create({
              component: InputSelectModalComponent,
              cssClass: 'select-modal',
              componentProps: {
                content: this.otpVerificationTemp,
                hideFooter: true
              },
            });
          } else {
            // open otp verification popup
            otpVerificationPopup = await this.modalCtrl.create({
              component: OTPVerificationPage,
              cssClass: 'custom-popup',
              componentProps: {
                userData: verificatioData,
                operationType: 'checkout-verification',
                previousCodeSentVia: verificationResponse.sentVia
              }
            });
          }

          if (otpVerificationPopup) {
            await otpVerificationPopup.present();
            // on dismiss check returned data 
            await otpVerificationPopup.onDidDismiss().then((response: any) => {

              this.verificationInProgress = false;

              if (response.data && response.data.isVerified) {
                this.appService.appObject.user.is_verified = response.data.isVerified;
                this.appService.updateAppObject();
              } else {
                verificationFail = true;
                return;
              }
            });
          }
        }


      }).catch((error) => {
        this.verificationInProgress = false;
        verificationFail = true;

        return;
      });
    }

    if (verificationFail) {
      if (this.debugOn) console.log('validation failed');
      return;
    }
    // <---------------- Verification END ----------------->

    // check if user has already claimed the welcome gift pacakge, if has remove it from the orderobject
    if (!this.appService.appObject.loggedInUserData || !this.appService.appObject.loggedInUserData.eligible_for_welcome_order) {
      if (this.appService.appObject.orderObject.claimWelcomePackage) {
        this.appService.showToast('You\'re not eligible for the free welcome package!', 'danger', 'top')
      }
      this.appService.appObject.orderObject.claimWelcomePackage = false;
    }

    if (this.is_subscription_order) {

      this.showSelectDaysError = false;
      if (this.selectedSubscribtionDates.length <= 0) {
        this.showSelectDaysError = true;
        if (this.debugOn) console.log('am called 3');
        return;
      }


      this.showSelectStartDateError = false;
      if (this.subscriptionOrderStartDate === '') {
        if (this.debugOn) console.log('am called 4');
        this.showSelectStartDateError = true;
        return;
      }

      this.showEndDateError = false;
      if (this.subscriptionHasEndDate && !this.subscriptionOrderEndDate) {
        if (this.debugOn) console.log('am called 5');
        this.showEndDateError = true;
        return;
      }

      this.showEndDateCannotBeGraterThanStartDateError = false;
      if (Date.parse(this.subscriptionOrderStartDate) > Date.parse(this.subscriptionOrderEndDate)) {
        if (this.debugOn) console.log('am called 6');
        this.showEndDateCannotBeGraterThanStartDateError = true;
        return;
      }
    }

    if (this.isGenaralSpecialOrderModeEnabled && !this.is_subscription_order) {
      this.showSelectSpecialDateError = false;
      if (this.specialDate === '') {
        if (this.debugOn) console.log('am called 97');
        this.showSelectSpecialDateError = true;
        return;
      }
      if (this.showSpecialOrderNotAvailableError) {
        if (this.debugOn) console.log('am called 98');
        return;
      }
      if (this.showSpecialOpenCloseError) {
        if (this.debugOn) console.log('am called 99');
        return;
      }
    }

    if(!this.isGenaralSpecialOrderModeEnabled && !this.is_subscription_order && !this.selectedDeliveryTimeValue){
      this.showSelectTimeError = true;
      return;
      
    }

    if (this.appService.appObject.selectedDeliveryMethod === 'delivery' && !this.verifyAddressComponents()) return;

    // 2023-09-04
    // check selected dish categories availability
    this.showMenuCategoriesNotAvailableError = false;
    if (this.checkMenuCategoriesAvailability()) {
      this.showMenuCategoriesNotAvailableError = true;
      if (this.debugOn) console.log('am called 2');
      return;
    }

    // 2022-12-01 since today there is a new feature to enable or disable payment options for specific ordering type
    // so added new validation to make sure that the user has selected a payment option
    if (!this.selectedPaymanetMethod) {
      this.showSelectPaymentMethodError = true;
      if (this.debugOn) console.log('am called 1');
      this.translate.get('key.select_a_payment_option').subscribe((data) => {
        this.appService.showToast(data, 'danger');
      })
      return;
    }
    this.showSelectPaymentMethodError = false;
    // end payment option select validation

    // added another condition to point payment gateway, just in case
    if (this.selectedPaymanetMethod === 'points' && this.appService.appObject.selectedDeliveryMethod === 'dine_in' && this.appService.appObject.selectedRestaurantDetails.is_bar_mode === 'true' && (!this.isOrderAmountPointsReached || !this.isMinimumPointsAmountReached)) return;

    // Postal code mode validations 
    if (this.appService.appObject.selectedDeliveryMethod === 'delivery' && this.appService.appObject.settings.is_postalcode === 'true') {
      if (this.appService.appObject.postalCodeDetails) {
        let listOfPostalCodes = this.appService.appObject.selectedRestaurantDetails.postal_code_details_v2;
        if (listOfPostalCodes) {
          if (!Array.isArray(listOfPostalCodes)) listOfPostalCodes = JSON.parse(listOfPostalCodes);
          let selectedExists = listOfPostalCodes.find((postalCode) => postalCode.code === this.appService.appObject.postalCodeDetails.code && postalCode.name === this.appService.appObject.postalCodeDetails.name);
          if (!selectedExists) {
            this.appService.showToast(this.lang.selected_restaurent_not_delivery_city, 'danger');
            return;
          }
          else console.log('postal code supported');
        } else {
          // show error
          this.appService.showToast(this.lang.selected_restaurent_not_delivery_city, 'danger');
          return;
        }
      } else {
        // show error
        console.log('postal code not selected by user');
        return;
      }
    }

    this.showSelectAddressError = false;

    //this.keyboard.disableScroll(false);
    let d_date = this.selectedDeliveryDateValue;
    
    // check if the date is empty when its only has genaral ordering mode enabled
    if(!d_date && !this.is_subscription_order && (this.isGenaralOrderModeEnabled && !this.isGenaralSpecialOrderModeEnabled)){
      this.dateCannotBeEmpty = true;
      return;
    }

    // condition was before "this.checkoutForm.valid"
    if (true) {

      if (this.selectedDeliveryTimeValue == 'asap') {
        d_date = 'asap';
      }

      this.appService.appObject.orderObject.order_details.name = this.addressForm.name.trim();
      this.appService.appObject.orderObject.order_details.email = this.addressForm.email.trim();
      this.appService.appObject.orderObject.order_details.mobile_number = this.addressForm.mobile_number;
      this.appService.appObject.orderObject.order_details.backyard = this.addressForm.backyard;
      this.appService.appObject.orderObject.order_details.company = this.addressForm.company;
      this.appService.appObject.orderObject.order_details.special_note = this.orderInstructions;
      this.appService.appObject.orderObject.order_details.payment_type = this.selectedPaymanetMethod;
      this.appService.appObject.orderObject.order_details.delivery_date = d_date;
      this.appService.appObject.orderObject.order_details.delivery_time = this.selectedDeliveryTimeValue;
      this.appService.appObject.orderObject.order_details.delivery_type = this.appService.appObject.selectedDeliveryMethod;
      this.appService.appObject.orderObject.order_details.is_subscription_order = this.is_subscription_order;
      this.appService.appObject.orderObject.order_details.order_schedule_type = this.order_schedule_type;
      this.appService.appObject.orderObject.order_details.order_days = this.selectedSubscribtionDates;
      this.appService.appObject.orderObject.order_details.is_end_date = this.subscriptionHasEndDate;
      this.appService.appObject.orderObject.order_details.end_date = this.subscriptionOrderEndDate;
      this.appService.appObject.orderObject.order_details.start_date = this.subscriptionOrderStartDate;
      this.appService.appObject.orderObject.order_details.specialDate = this.specialDate;
      this.appService.appObject.orderObject.order_details.isGenaralSpecialOrderModeEnabled = this.isGenaralSpecialOrderModeEnabled;
      // console.log('this.appService.appObject.myAddress.name : ', this.appService.appObject.myAddress.name);

      // <---------------- (including) Gather address book data START ----------------->
      let addressBookObject = {
        id: null,
        street: '',
        houseNumber: '',
        postalCode: '',
        city: '',
        is_postalcode_mode: 'false'
      }

      if (this.appService.appObject.selectedDeliveryMethod === 'delivery' && this.appService.appObject.settings.is_postalcode !== 'true') {
        let streetNumber = this.addressForm.street_number.trim();
        this.appService.appObject.addressBookObject.houseNumber = streetNumber;

        if (streetNumber && this.currentlySelectedAddress) {
          let splitedAddress = this.currentlySelectedAddress.split(',');
          // console.log('splited  3 : ' , splitedAddress);
          let newAddress = '';
          if (splitedAddress.length === 3) {
            newAddress = splitedAddress[0].trim() + ', ' + streetNumber + ', ' + splitedAddress[1].trim() + ', ' + splitedAddress[2].trim();
            this.appService.appObject.addressBookObject.street = splitedAddress[0].trim();
            this.appService.appObject.addressBookObject.postalCode = splitedAddress[1].trim();
            this.appService.appObject.addressBookObject.city = splitedAddress[2].trim();
          } else if (splitedAddress.length === 4) {
            newAddress = splitedAddress[0].trim() + ', ' + streetNumber + ', ' + splitedAddress[2].trim() + ', ' + splitedAddress[3].trim();
            this.appService.appObject.addressBookObject.street = splitedAddress[0].trim();
            this.appService.appObject.addressBookObject.postalCode = splitedAddress[2].trim();
            this.appService.appObject.addressBookObject.city = splitedAddress[3].trim();
            // console.log('splited  4 : ' , splitedAddress);
          }
          this.appService.appObject.myAddress.name = newAddress;
        }
      } else if (this.appService.appObject.selectedDeliveryMethod === 'delivery' && this.appService.appObject.settings.is_postalcode === 'true') {
        this.appService.appObject.myAddress.name = this.addressForm.address.trim();
        let streetNumber = this.addressForm.street_number.trim();

        this.appService.appObject.addressBookObject.is_postalcode_mode = 'true';
        this.appService.appObject.addressBookObject.houseNumber = streetNumber;
        this.appService.appObject.addressBookObject.city = this.postalCodeDetails.name;
        this.appService.appObject.addressBookObject.postalCode = this.postalCodeDetails.code;

        this.appService.appObject.addressBookObject.name = this.addressForm.name;
        this.appService.appObject.addressBookObject.mobile_number = this.addressForm.mobile_number;
        this.appService.appObject.addressBookObject.backyard = this.addressForm.backyard;

        // let houseNumber = checkoutdetails.house_number.trim();
        // concat postal code details to end of the user entered address
        if (this.appService.appObject.myAddress.name) {
          this.appService.appObject.myAddress.name += (' ' + streetNumber) + (', ' + this.postalCodeDetails.name + ' ' + this.postalCodeDetails.code);
          // this is a trick to slove when user select address from street input without street number. we must re asasamble the address text before place order
          this.appService.appObject.addressObjectForPostalCode.streetNo = streetNumber;
          this.appService.appObject.addressObjectForPostalCode.postalCodenCity =  (', ' + this.postalCodeDetails.code + ' ' + this.postalCodeDetails.name);
        }
      }

      if (this.appService.appObject.selectedDeliveryMethod === 'delivery') {
        this.appService.appObject.addressBookObject.name = this.addressForm.name;
        this.appService.appObject.addressBookObject.mobile_number = this.addressForm.mobile_number;
      }

      // set address book object to app object  
      // if (this.appService.appObject.selectedDeliveryMethod === 'delivery') {
      //   this.appService.appObject.addressBookObject = addressBookObject;
      //   this.appService.updateAppObject();
      // }
      // <---------------- Gather address book data END ----------------->

      console.log('this.addressForm.address : ', this.addressForm.address);
      console.log('this.appService.appObject.myAddress.name : ', this.appService.appObject.myAddress.name);


      this.appService.appObject.myAddress.name = this.addressForm.address.trim();
      this.appService.appObject.myAddress.lat = this.addressForm.lat;
      this.appService.appObject.myAddress.lng = this.addressForm.lng;

      // new condition added to skip address details
      // when google auto complete disabled, there will be no any auto filled details
      // so instead of returning an error, implement error handling for this new feature
      if (this.appService.disableGoogleAutoComplete) {
        const { city, street, postal_code, street_number } = this.addressForm;
        if (city?.trim() && street?.trim() && postal_code?.trim() && street_number?.trim()) {

          const fullAddress = `${street} ${street_number}, ${postal_code} ${city}`;
          this.appService.appObject.addressBookObject.address = this.appService.appObject.myAddress.name = this.addressForm.address = fullAddress;
          this.appService.appObject.addressObjectForPostalCode.streetNo = street_number;
          this.appService.appObject.addressObjectForPostalCode.street = street;

        } else {
          this.showSelectAddressError = true;
          console.log('error in address');
          return;
        }
      }

      // check address string only if the selected ordering method is delivery
      if (this.appService.appObject.selectedDeliveryMethod === 'delivery' && !this.appService.appObject.myAddress.name) {
        this.showSelectAddressError = true;
        console.log('error....');

        return;
      }

      // return;

      if (!this.appService.isWebVersion){
        this.appService.placeOrder().then((res) =>{
          console.log('res : ', res);
        }).catch((error) =>{
          console.log(error);
          if(error && error.code === 'INSUF_POINTS'){
            this.openPointRechargeModal();
          }
        });
      } else {
        let paymentOp = this.appService.appObject.orderObject.order_details.payment_type;
        this.appService.placeOrder(true).then((response: any) => {
          //paymentAlreadyMade you can trigger this condition from the backend
          if (response.paymentAlreadyMade || paymentOp === 'cod' || paymentOp === 'ecCard' || paymentOp === 'points') {
            if (response.payment_id) this.onOrderPlaced.emit([response.payment_id, this.appService.appObject.selectedDeliveryMethod, 'general']);
            if (response.subscription_id) this.onOrderPlaced.emit([response.subscription_id, this.appService.appObject.selectedDeliveryMethod, 'subscription']);
          }
        }).catch((error) => {
          if(error && error.code === 'INSUF_POINTS') this.openPointRechargeModal();
          else this.onOrderPlaceError.emit(error);
        });
      }

      // keep last order postal code details after placing an order
      // if (this.appService.appObject.selectedDeliveryMethod === 'delivery' && this.appService.appObject.settings.is_postalcode === 'true') {
      //   this.appService.appObject.postalCodeExtraDetails = {
      //     streetNumber: this.addressForm.street_number.trim(),
      //     address: this.addressForm.address.trim(),
      //     street: this.addressForm.street.trim(),
      //     lat: this.addressForm.lat,
      //     lng: this.addressForm.lng,
      //   }

      //   this.appService.updateAppObject();
      // }

    }

  }

  /**
 * 
 * get languages
 */
  async getLang() {
    await this.translate.get('key').subscribe(
      value => {
        this.lang = value;
      }
    )
  }

  /**
   * Will trigger when user choose a payment method
   * @param method selected payment method
   */
  onPaymentMethodSelect(method) {
    console.log(method);
    // this.selectedPaymanetMethod = method.id;
    this.appService.appObject.orderObject.selectedPaymentMethod = method.id;
    this.paymentModal.dismiss();
    
    // if points method selected clear tips 
    // this is just for now
    if(method.id === 'points'){
      this.resetTips();
    }
    this.appService.calculateCartAmountsV2();
  }

  /**
   * Will trigger when user tap on days in the subscribe days list
   * @param selectedWeekDay selected day string
   */
  async onSubscriptionOrderDayTap(selectedWeekDay) {
    let index = this.selectedSubscribtionDates.findIndex((day) => day === selectedWeekDay);
    if (index >= 0) {
      this.selectedSubscribtionDates.splice(index, 1);
    } else {
      this.selectedSubscribtionDates.push(selectedWeekDay);
    }

    await this.selectDats();

    this.onTimeChangeOrCartChange();
  }


  async selectStartDate(selectedDate, doNotAssignAsActualDate:boolean = false) {
    console.log('Pai 01');

    // when comming from selected day is closed validation, selected date won't assign to display until find the next available day
    if(!doNotAssignAsActualDate) {
      this.subscriptionOrderActualStartDate = selectedDate;
    }

    if (this.selectedSubscribtionDates.length > 0) {
      var check = this.checkIsTimePassed(this.subscription_order_cutoff_time)
      var getTodayGivenDay: any;
      let dateList = [];

      for (let index = 0; index < this.selectedSubscribtionDates.length; index++) {
        let daynumber = await this.dayNum(this.selectedSubscribtionDates[index]);
        let cutoffday = this.availableSubscriptionDays.find((day) => day.day.toUpperCase() === this.selectedSubscribtionDates[index].toUpperCase());
        if (!cutoffday.subscription_order_cutoff_day) {
          cutoffday.subscription_order_cutoff_day = 0;
        }
        if (check) {
          getTodayGivenDay = this.getTodayPlusGivenDaysDay(parseInt(cutoffday.subscription_order_cutoff_day) + 1);
        } else {
          getTodayGivenDay = this.getTodayPlusGivenDaysDay(parseInt(cutoffday.subscription_order_cutoff_day));
        }
        const d1 = new Date(getTodayGivenDay);
        const d2 = new Date(selectedDate);
        if (d2 <= d1) {
          d1.setDate(d1.getDate() + (daynumber + 7 - d1.getDay()) % 7);
          dateList.push(d1);
        } else {
          d2.setDate(d2.getDate() + (daynumber + 7 - d2.getDay()) % 7);
          dateList.push(d2);
        }
      }

      let sorted = dateList.sort((a, b) => a.getTime() - b.getTime());

      // this will indicate that startDateChange event will be called due to the below code execution.
      // and we should void that 
      this.isAboutToTriggerStartDateChange = true;
      
      this.subscriptionOrderStartDate = this.formatDate(sorted[0]);
      // this.subscriptionOrderActualStartDate = this.formatDate(sorted[0]);

      if(!doNotAssignAsActualDate) {
        await this.checkSecialOpenCloseDay();
      };

      // lets check if the selected date is in special closed dates
      if(this.subscriptionOpenCloseData && this.subscriptionOpenCloseData.length){
        let closedDate = this.subscriptionOpenCloseData.find((closedDate) => closedDate.date === this.formatDate(sorted[0]));
        // if selected day is not in the closed days list, everything is fine. the selected day is available
        if(!closedDate){
          // this.subscriptionOrderStartDate = this.formatDate(sorted[0]);
        }else{
          // if selected day is closed and there are other available days in sorted available days list
          if(sorted.length > 1){
            let availableDateFound = false;
            // check every available days in sorted days list to find out if at least one available day for current week
            for (let index = 1; index < sorted.length; index++) {
              const element = sorted[index];
              let closedDate = this.subscriptionOpenCloseData.find((closedDate) => closedDate.date === this.formatDate(element));
              if(!closedDate){
                availableDateFound = true;
                this.subscriptionOrderStartDate = this.formatDate(element);
                break;
              }
            }

            // if there is no available days in sorted list moved to next week by adding 1 day to the last available day in the sorted list
            // do the same to find at least one available day
            if(!availableDateFound){
              let forceChangeUserSelectedDateToFindNextAvailableDate = new Date(this.formatDate(sorted[sorted.length - 1]));  
              forceChangeUserSelectedDateToFindNextAvailableDate.setDate(forceChangeUserSelectedDateToFindNextAvailableDate.getDate()+1);
              this.selectStartDate(this.formatDate(forceChangeUserSelectedDateToFindNextAvailableDate), true);
            }
          }else{
            // if there is no any available days for this week, then add another day to selected day and do the same for next week data
            let forceChangeUserSelectedDateToFindNextAvailableDate = new Date(this.formatDate(sorted[0]));
            forceChangeUserSelectedDateToFindNextAvailableDate.setDate(forceChangeUserSelectedDateToFindNextAvailableDate.getDate()+1);
            this.selectStartDate(this.formatDate(forceChangeUserSelectedDateToFindNextAvailableDate), true);
          }
        }
      }


    }
  }

  async dayNum(value) {
    // console.log('EE',value);
    if (value === 'MON') {
      return 1;
    }
    if (value === 'TUE') {
      return 2;
    }
    if (value === 'WED') {
      return 3;
    }
    if (value === 'THU') {
      return 4;
    }
    if (value === 'FRI') {
      return 5;
    }
    if (value === 'SAT') {
      return 6;
    }
    if (value === 'SUN') {
      return 7;
    }
  }

  checkIsTimePassed(giventime) {
    var get_day = this.getSelectePlusGivenDay(0, giventime);
    var now = new Date();
    var d = new Date(get_day); // pass all the parameters you need to create the time
    if (now.getTime() > d.getTime()) {
      // the date stored in `d` is in the past.
      return true;
    } else {
      return false;
    }
  }

  getTodayPlusGivenDaysDay(givendays,useThisDate = null) {
    const today = useThisDate ?  new Date(useThisDate)  : new Date();
    const plusDay = new Date(today);
    const pday = today.setDate(plusDay.getDate() + givendays);
    var onlyday = this.formatDate(pday);
    return new Date(onlyday);
  }

  formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }


  getSelectePlusGivenDay(givendays, giventime) {
    const today = new Date();
    const plusDay = new Date(today);
    const pday = today.setDate(plusDay.getDate() + givendays);
    var onlyday = this.formatDate(pday);
    if(giventime == 0){
      return new Date(onlyday);
    }
    return new Date(onlyday + 'T' + giventime);
  }


  async selectDats(useThisDate = null) {
    console.log('Pai 02');

    if (this.selectedSubscribtionDates.length > 0) {
      this.showSelectDaysError = false;
      var check = this.checkIsTimePassed(this.subscription_order_cutoff_time)
      var getTodayPlusGivenDay: any;
      let dateList = [];

      for (let index = 0; index < this.selectedSubscribtionDates.length; index++) {
        let cutoffday =this.availableSubscriptionDays.find((day) => day.day.toUpperCase() === this.selectedSubscribtionDates[index].toUpperCase());
        if(!cutoffday.subscription_order_cutoff_day){
          cutoffday.subscription_order_cutoff_day = 0;
        }
        if (check) {
          // useThisDate will come from when there is no single available days for current week
          // useThisDate is the date after the last available and specially closed date
          getTodayPlusGivenDay = this.getTodayPlusGivenDaysDay(parseInt(cutoffday.subscription_order_cutoff_day) + 1, useThisDate);
        } else {
          // useThisDate will come from when there is no single available days for current week
          // useThisDate is the date after the last available and specially closed date
          getTodayPlusGivenDay = this.getTodayPlusGivenDaysDay(parseInt(cutoffday.subscription_order_cutoff_day), useThisDate);
        }
        let daynumber = await this.dayNum(this.selectedSubscribtionDates[index]);
        var d = new Date(getTodayPlusGivenDay);
        d.setDate(d.getDate() + (daynumber + 7 - d.getDay()) % 7);
        dateList.push(d);
      }

      let sorted = dateList.sort((a, b) => a.getTime() - b.getTime());

      // this will indicate that startDateChange event will be called due to the below code execution.
      // and we should void that 
      this.isAboutToTriggerStartDateChange = true;
      this.subscriptionOrderStartDate = this.formatDate(sorted[0]);
      this.subscriptionOrderActualStartDate = this.formatDate(sorted[0]);

      await this.checkSecialOpenCloseDay();


      // lets check if the selected date is in special closed dates
      if(this.subscriptionOpenCloseData && this.subscriptionOpenCloseData.length){
        let closedDate = this.subscriptionOpenCloseData.find((closedDate) => closedDate.date === this.formatDate(sorted[0]));
        // if selected day is not in the closed days list, everything is fine. the selected day is available
        if(!closedDate){
          // this.subscriptionOrderStartDate = this.formatDate(sorted[0]);
        }else{
          if(sorted.length > 1){
            let availableDateFound = false;
            // check every available days in sorted days list to find out if at least one available day for current week
            for (let index = 1; index < sorted.length; index++) {
              const element = sorted[index];
              let closedDate = this.subscriptionOpenCloseData.find((closedDate) => closedDate.date === this.formatDate(element));
              if(!closedDate){
                availableDateFound = true;
                this.subscriptionOrderStartDate = this.formatDate(element);
                break;
              }
            }

            // if there is no available days in sorted list moved to next week by adding 1 day to the last available day in the sorted list
            // do the same to find at least one available day
            if(!availableDateFound){
              let forceChangeUserSelectedDateToFindNextAvailableDate = new Date(this.formatDate(sorted[sorted.length - 1]));  
              forceChangeUserSelectedDateToFindNextAvailableDate.setDate(forceChangeUserSelectedDateToFindNextAvailableDate.getDate()+1);
              this.selectDats(this.formatDate(forceChangeUserSelectedDateToFindNextAvailableDate));
            }
          }else{
            // if there is no any available days for this week, then add another day to selected day and do the same for next week data
            let forceChangeUserSelectedDateToFindNextAvailableDate = new Date(this.formatDate(sorted[0]));
            forceChangeUserSelectedDateToFindNextAvailableDate.setDate(forceChangeUserSelectedDateToFindNextAvailableDate.getDate()+1);
            this.selectDats(this.formatDate(forceChangeUserSelectedDateToFindNextAvailableDate));
          }
        }
      }

      ///////// ????? >>>>>>>>>>   
      // for (let ind = 0; ind < sorted.length; ind++) {
      //   console.log('Day .',this.subscriptionOpenOnlyCloseData.includes(this.formatDate(sorted[ind])));
      //   if (this.subscriptionOpenCloseData.includes(sorted[ind])) {
      //     console.log('Day exists in the array.');
      //   } else {
      //     console.log('Day does not exist in the array.');
      //   }
      // }

      // when user select subsription type as weekly and select dates, check menu category availability
      this.showMenuCategoriesNotAvailableError = false;
      if (this.checkMenuCategoriesAvailability()) {
        this.showMenuCategoriesNotAvailableError = true;
      }
      this.isAboutToTriggerStartDateChange = false;
    }

  }

  /**
   * When user change address
   */
  changeDeliveryLocation() {
    if (!this.appService.isWebVersion) this.openAddressChangePopup()// this.router.navigate(['/find-near-by-me'])
    else this.onChangeDeliveryAddress.emit();
  }

  async openAddressChangePopup() {

    const modal = await this.modalCtrl.create({
      component: SelectOrderTypePage,
      cssClass: 'custom-popup',

      componentProps: {
        'currentUI': 'delivery-address',
        'just_select_address': 'true',
        'is_from_checkout_page': 'true'
      }
    });

    await modal.present();

    modal.onDidDismiss().then((dismissed) => {
      this.onDismissAddressSelect();
    });
  }

  onDismissAddressSelect() {
    if (this.appService.appObject.myAddress && this.appService.appObject.myAddress.name && this.appService.appObject.myAddress.lat && this.appService.appObject.myAddress.lng) {
      this.currentlySelectedAddress = this.appService.appObject.myAddress.name;

      this.addressForm.address = this.appService.appObject.myAddress.name;
      this.addressForm.lat = this.appService.appObject.myAddress.lat;
      this.addressForm.lng = this.appService.appObject.myAddress.lng;

      console.log('this.appService.appObject.myAddress: ', this.appService.appObject.myAddress);


      // auto fill the street number if available from previousely selected valid address
      this.addressForm.street_number = this.appService.appObject.myAddress && this.appService.appObject.myAddress.streetNo ? this.appService.appObject.myAddress.streetNo : '';
    } else {
      this.currentlySelectedAddress = '';
      this.addressForm.street_number = '';
    }
  }

  async setSpecialDate(specialDate){
    this.showSelectSpecialDateError = false;
    this.showSpecialOrderNotAvailableError = false;
    await this.checkSecialOpenCloseDay();
    if (!this.showSpecialOpenCloseError) {
      this.setSpecialMinDate(specialDate);
      
    }
  }

  setSpecialMinDate(specialDate) {
    this.showSpecialOpenCloseError = false;
    this.showSpecialOrderNotAvailableError = false;
    var isPassedCutoffTime = this.checkIsTimePassed(this.special_order_cutoff_time);
    var getTodayPlusGivenDay: any;

    let todayName = this.daysOfWeek[new Date(specialDate).getDay()];
    let cutoffday =this.availableSpecialDays.find((day) => day.day.toUpperCase() === todayName.toUpperCase());
    
    if(!cutoffday.general_order_cutoff_day){
      cutoffday.general_order_cutoff_day = 0;
    }
    
    getTodayPlusGivenDay = this.getTodayPlusGivenDaysDay(parseInt(cutoffday.general_order_cutoff_day));

    const d1 = new Date(getTodayPlusGivenDay);
    const d2 = new Date(specialDate);

    let cond2 = this.selectSpecialDate(specialDate);

    console.log("d2 :: d1",d2 , d1);

    let todayDayNo = this.dayNum(todayName);
    let specialSelectedDate = new Date(specialDate);
    specialSelectedDate.setDate(specialSelectedDate.getDate() - cutoffday.general_order_cutoff_day);
    let orderMustPlaceAtDate = this.daysOfWeek[specialSelectedDate.getDay()];

    if (cond2) {
      if (d2 <= d1) {
        if (d2.getTime() === d1.getTime()) {
          if (isPassedCutoffTime) {
            this.translate.get(['key.you_must_place_orders_for','key.in_advance','key.'+todayName,'key.before','key.'+orderMustPlaceAtDate,'key.week_in_advance']).toPromise().then((translation) => {
              if (cutoffday.general_order_cutoff_day === 0) {
                this.specialOpenCloseMsg = translation['key.you_must_place_orders_for']+' '+translation['key.'+todayName]+' '+translation['key.before']+' : '+this.special_order_cutoff_time;
              } else if (cutoffday.general_order_cutoff_day === 6){
                this.specialOpenCloseMsg = translation['key.you_must_place_orders_for']+' '+translation['key.'+todayName]+' '+translation['key.before']+' '+translation['key.week_in_advance'];
              } else if (cutoffday.general_order_cutoff_day > 6){
                this.specialOpenCloseMsg = translation['key.you_must_place_orders_for']+' '+translation['key.'+todayName]+' '+translation['key.before']+' '+cutoffday.general_order_cutoff_day+' '+translation['key.in_advance'];
              } else {
                this.specialOpenCloseMsg = translation['key.you_must_place_orders_for']+' '+translation['key.'+todayName]+' '+translation['key.before']+' '+translation['key.'+orderMustPlaceAtDate]+' : '+this.special_order_cutoff_time;
                // this.specialOpenCloseMsg = translation['key.you_must_place_orders_for']+' '+translation['key.'+todayName]+' '+cutoffday.general_order_cutoff_day+' '+translation['key.in_advance'];
              }
            });
            this.showSpecialOpenCloseError = true;
          }
        } else {
          this.translate.get(['key.you_must_place_orders_for','key.in_advance','key.'+todayName,'key.before','key.'+orderMustPlaceAtDate,'key.week_in_advance']).toPromise().then((translation) => {
            if (cutoffday.general_order_cutoff_day === 0) {
              this.specialOpenCloseMsg = translation['key.you_must_place_orders_for']+' '+translation['key.'+todayName]+' '+translation['key.before']+' '+translation['key.'+orderMustPlaceAtDate]+' : '+this.special_order_cutoff_time;
            } else if (cutoffday.general_order_cutoff_day === 6){
              this.specialOpenCloseMsg = translation['key.you_must_place_orders_for']+' '+translation['key.'+todayName]+' '+translation['key.before']+' '+translation['key.week_in_advance'];
            } else if (cutoffday.general_order_cutoff_day > 6){
              this.specialOpenCloseMsg = translation['key.you_must_place_orders_for']+' '+translation['key.'+todayName]+' '+translation['key.before']+' '+cutoffday.general_order_cutoff_day+' '+translation['key.in_advance'];
            } else {
              this.specialOpenCloseMsg = translation['key.you_must_place_orders_for']+' '+translation['key.'+todayName]+' '+translation['key.before']+' '+translation['key.'+orderMustPlaceAtDate]+' : '+this.special_order_cutoff_time;// +cutoffday.general_order_cutoff_day+' '+translation['key.in_advance'];
            }
          });
          this.showSpecialOpenCloseError = true;
        }
      }
    }

  }

  selectSpecialDate(special_date) {
    var d = new Date(special_date);
    const orderDay = this.daysOfWeek[new Date(d).getDay()];
    if (this.appService?.appObject?.selectedRestaurantDetails['available_special_days'].includes(orderDay)) {
      this.showSpecialOrderNotAvailableError = false;
      return true;
    } else {
      this.showSpecialOrderNotAvailableError = true;
      return false;
    }
  }

  /**
   * Will check available payment options in selected restauratn in selected scenarios and return available methods list
   * @returns available payment options array
   */
  getAvailablePaymentOptions() {
    if (this.appService.appObject.selectedRestaurantDetails && this.appService.appObject.selectedRestaurantDetails.payment_methods) {
      let methods = this.appService.appObject.selectedRestaurantDetails.payment_methods;
      let availablePaymentOptions = [];
      // console.log('methods: ', methods);

      if (this.is_subscription_order) {
        availablePaymentOptions = methods.filter((method) =>
          method.availableForBackaryMode === 'true'
          && method.isActive === 'true'
          && method['is_' + this.appService.appObject.selectedDeliveryMethod] === 'true');
      } else {
        availablePaymentOptions = methods.filter((method) => {
          if (method.id !== 'points') {
            return method.isActive === 'true' && method['is_' + this.appService.appObject.selectedDeliveryMethod] === 'true'
          } else {
            return method.isActive === 'true' && method['is_' + this.appService.appObject.selectedDeliveryMethod] === 'true' && this.appService.appObject.isAuthed
          }
        });
      }

      // remove Cash option if user is trying to place a delivery order while uber direct API is enabled
      if(this.appService.appObject.selectedRestaurantDetails && this.appService.appObject.selectedRestaurantDetails.delivery_via_uber === 'true' && this.appService.appObject.selectedDeliveryMethod === 'delivery'){
        let codOptionIndex = availablePaymentOptions.findIndex((mehod) => mehod.id === 'cod')
        if(codOptionIndex !== -1){
          availablePaymentOptions.splice(codOptionIndex,1);
        }
      }
      
      return availablePaymentOptions;
    } else {
      return [];
    }
  }

  /**
   * Will trigger when user enable disable subscription mode
   * unselect the selected payment option is not available for bakerymode
   * @param event 
   */
  onSubscriptioOrderModeChange(event) {
    setTimeout(() => {
      // if user check the subscription order, then let know that the coupon code is not supported
      if(this.is_subscription_order){
        this.confirm_Popup_Coupon_Not_Supported();
      }
      let availablePaymentOptions = this.getAvailablePaymentOptions();
      let foundSelectedOption = availablePaymentOptions.find((method) => method.id === this.selectedPaymanetMethod);
      if (!foundSelectedOption) {
        // console.log('payment option not available');
        this.selectedPaymanetMethod = '';
        this.selectedPaymanetMethodObject = null;
      }

    }, 100);
  }

  /**
   * This will force date pickers to open 
   * @param datePickerId date picker element id
   */
  forceOpenDatePicker(datePickerId: string) {
    // let element = document.getElementById('start-date-input');
    if (datePickerId && this[datePickerId]) {
      this[datePickerId].open();
    }
  }

  async checkSecialOpenCloseDay() {
    this.specialOpenCloseMsg = '';
    this.showSpecialOpenCloseError = false;
    this.subscriptionOpenCloseMsg = '';
    this.subscriptionOpenCloseData = [];
    this.showSubscriptionOpenCloseError = false;
    var details = {};
    if (this.is_subscription_order) {
      details = {
        'type' : 'subscription',
        'restaurant_id': this.appService.appObject.selectedRestaurantId,
        'start_date': this.subscriptionOrderStartDate,
        'end_date': this.subscriptionHasEndDate ? this.subscriptionOrderEndDate : null,
        'days': this.selectedSubscribtionDates
      }
    }
    if (this.isGenaralSpecialOrderModeEnabled && !this.is_subscription_order) {
      details = {
        'type' : 'special',
        'restaurant_id': this.appService.appObject.selectedRestaurantId,
        'date': this.specialDate
      }
    }
    if (details){ // details && this.appService.appObject.isAuthed
      this.appService.appObject.isLoading = true;
      await this.appService.checkSecialOpenCloseDay(details).then((data: any) => {
        if (data.status) {
          return true;
        } else {
          if (this.is_subscription_order) {
            // console.log("Sub :",data);
            this.subscriptionOpenCloseMsg = data.msg;
            this.subscriptionOpenCloseData = data.closed_days;
            this.subscriptionOpenOnlyCloseData = data.only_closed_days;
            this.showSubscriptionOpenCloseError = true;
            return false;
          }
          if (this.isGenaralSpecialOrderModeEnabled && !this.is_subscription_order) {
            // console.log("Spe :",data);
            this.specialOpenCloseMsg = data.msg;
            this.showSpecialOpenCloseError = true;
            return false;
          }
        }
        this.appService.appObject.isLoading = false;
      }, error => {
        this.appService.appObject.isLoading = false;
      });
    }
  }

  changeOrderType(){
    if (this.onInitBool) {
      this.onInitBool = !this.onInitBool;
    } else {
      this.is_subscription_order = !this.is_subscription_order;
      this.selectedSubscribtionDates = [];
    }
  }

  async openCalendarPopUp(action) {
    const welcomePopup = await this.modalCtrl.create({
      component: CalendarPage,
      cssClass: 'select-modal',
      componentProps: {
        'defaultDate': action === 'start' ? this.subscriptionOrderActualStartDate : action === 'special' ? this.specialDate : this.subscriptionOrderEndDate
      }
    });
    await welcomePopup.present();
    let response = await welcomePopup.onDidDismiss()
    if (response && response.data && response.data.selectedDate) {
      if (action === 'start') {
        this.selectStartDate(response.data.selectedDate);
        console.log('response : 1');
      } else if (action === 'special'){
        console.log('response : 2');
        this.specialDate = response.data.selectedDate;
        this.setSpecialDate(response.data.selectedDate);
      } else {
        console.log('response : 3');
        this.subscriptionOrderEndDate = response.data.selectedDate;
        this.showEndDateError = false;
        if (this.subscriptionHasEndDate && !this.subscriptionOrderEndDate) {
          if (this.debugOn) console.log('am called 5');
          this.showEndDateError = true;
          return;
        }
        this.showEndDateCannotBeGraterThanStartDateError = false;
        if (Date.parse(this.subscriptionOrderStartDate) > Date.parse(this.subscriptionOrderEndDate)) {
          this.showEndDateCannotBeGraterThanStartDateError = true;
          return;
        }
      }
    } else {
      console.log('response : 4');
    }
  }


  /**
  * Open points recharge popup
  */
  async openPointRechargeModal() {

    if (this.appService.appObject.pointEnabledRestaurantsList && this.appService.appObject.pointEnabledRestaurantsList.length) {
      let selectedRestaurant = this.appService.appObject.pointEnabledRestaurantsList.find((restaurant) => restaurant.id === this.appService.appObject.selectedRestaurantDetails.id);

      if (!selectedRestaurant) return;

      const modal = await this.modalCtrl.create({
        component: InputSelectModalPointsComponent,
        cssClass: 'select-modal',
        componentProps: {
          selectedRestaurant: selectedRestaurant,
          forcedToRecharge: true
        },
      });
      // hide cart button when popup opening
      this.appService.hideCartButton = true;

      modal.present();
      // console.log(modal);
      modal.onWillDismiss().then(async (event) => {
        // modal dismissed
      });
    }
  }

  /**
   * Opens confirm dialog to decide wether recharge or not
   */
  async confirmPopup() {
    this.appService.hideCartButton = true;
    let translate = await this.translate.get(['key.not_now', 'key.ok', 'key.your_point_balance_is_0', 'key.lets_recharge_points_to_the_selected_restaurant']).toPromise();
    const modal = await this.modalCtrl.create({
      component: CustomConfirmDialogComponent,
      cssClass: 'select-modal',
      componentProps: {
        title: translate['key.your_point_balance_is_0'] + '!',
        messageBody: translate['key.lets_recharge_points_to_the_selected_restaurant'] + '?',
        cancelText: translate['key.not_now'],
        confirmText: translate['key.ok'],
        onAction: (action) => {
          if (action.role === 'confirm') {
            this.openPointRechargeModal();
          }else{
            this.appService.hideCartButton = false;
          }
          modal.dismiss();
        }
      }
    });

    modal.present();
  }

  /**
   * Will check if the selected coupon code is available for subscription orders 
   * @param askToRemove when this value is true, the popup message will show na option to remove the coupon code
   * @returns 
   */
  confirm_Popup_Coupon_Not_Supported(askToRemove:boolean = false) {
    // check if the selected coupon is support for subscription orders before open popup
    // only appears the selected coupon is not available for subscription orders
    if(this.appService.appObject.orderObject.cart_summery && this.appService.appObject.orderObject.cart_summery.coupon_details){
      if(this.appService.appObject.orderObject.cart_summery.coupon_details.available_for_subscriptions){
        return false;
      }
    }else{
      return false;
    }

    setTimeout(async () => {
      this.appService.hideCartButton = true;
      let translate = await this.translate.get(['key.cancel', 'key.ok','key.yes_remove_coupon', 'key.coupon_code_not_available_for_subscription_orders', 'key.coupon_code_is_not_available_for_subscription_orders_at_the_moment_want_to_remove', 'key.coupon_code_is_not_available_for_subscription_orders_at_the_moment', 'key.your_coupon_code_not_available_for_subscription_orders']).toPromise();
      const modal = await this.modalCtrl.create({
        component: CustomConfirmDialogComponent,
        cssClass: 'select-modal',
        componentProps: {
          title: translate['key.your_coupon_code_not_available_for_subscription_orders'] + '!',
          messageBody: askToRemove ? translate['key.coupon_code_is_not_available_for_subscription_orders_at_the_moment_want_to_remove'] : translate['key.coupon_code_is_not_available_for_subscription_orders_at_the_moment'],
          cancelText: askToRemove ? translate['key.cancel'] : '',
          confirmText: askToRemove ? translate['key.yes_remove_coupon'] : translate['key.ok'],
          onAction: (action) => {
            if(askToRemove && action.role === 'confirm'){
              // remove the coupon code here
              this.appService.clearCouponDetails();
            }
            this.appService.hideCartButton = false;
            modal.dismiss();
          }
        }
      });

      modal.present();

      modal.onDidDismiss().then(() => {
        this.appService.hideCartButton = false;
      })
    }, 10);

    return true;
  }

  // calculate cart amounts when user change delivery time
  async onTimeSlotChange() {
    this.appService.appObject.selectedTimeSlot = this.selectedDeliveryTimeValue === 'asap' ? '' : this.selectedDeliveryTimeValue;
    await this.appService.updateAppObject();
    // store current delivery cost to notify if there is any change of the delivery cost after calculation
    this.initialDeliveryCost = this.appService.appObject.orderObject.cart_summery.delivery_cost;
    await this.appService.calculateCartAmountsV2();
    // notify user that the delivery cost has been changed
    if(this.initialDeliveryCost !== this.appService.appObject.orderObject.cart_summery.delivery_cost){
      this.translate.get('key.delivery_cost_changed').subscribe((lang) =>{
        this.appService.showToast(lang,'secondary','middle',3000,'delivery-cost-changed-toast');
      });
    }
  }

  async openDeliveryTimeSlotDetails(event, openDetailComponent:boolean = false){
    const popover = await this.popoverCtrl.create({
      component: DeliveryTimesPage,
      cssClass: 'delivery-cost-tour-class',
      event: event,
      translucent: true,
      mode: 'ios',
      showBackdrop: true,
      backdropDismiss:true
    });
    await popover.present();
  }

  /**
   * Will apply selected tip amount to order total
   * @param isApplyBtn is triggered by apply button in custom amount input
   * @param tipAmount currently not in use
   */
  applySelectedTip(isApplyBtn:boolean = false, tipAmount:number = null){

    if(+(this.selectedTipAmountInNumber + '') <= 0){
      this.appService.showToast('Negative numbers are not allowed for tips!','danger','bottom',3000);
      this.resetTips();
      return;
    }

    if(isNaN(+(this.selectedTipAmountInNumber + ''))){
      this.appService.showToast('Invalid Tip Amount!','danger','bottom',3000);
      this.resetTips();
      return;
    }

    // if the same number is applied, that means user clicked on the same btn second time to remove the tip
    // and it's not from the custom tip apply button. so clear all the tip amounts
    if(this.appService.appObject.orderObject.tip_amount === +(this.selectedTipAmountInNumber + '') && !isApplyBtn){
      this.tipApplied = false;
      this.resetTips();
    }else{
      this.appService.appObject.orderObject.tip_amount = +(this.selectedTipAmountInNumber+'');

      if(isApplyBtn) this.tipApplied = true;
    }

    this.appService.calculateCartAmountsV2();
    // console.log('this.appService.appObject.orderObject.tip_amount : ' , this.appService.appObject.orderObject.tip_amount);
  }

  /**
   * Reset tips amounts
   */
  resetTips(){
    this.appService.appObject.orderObject.tip_amount = 0;
    this.appService.appObject.orderObject.is_tip_recurring = false;
    this.isTipRecurring = false;
    this.selectedTipAmountInNumber = null;
    this.selectedTipAmount = '';
    this.tipApplied = false;
    this.appService.calculateCartAmountsV2();
  }

  isTipRecurringChange(event){
    // there is a tiny delay of changing property value
    // so give it a 10 milis
    setTimeout(() => {
      this.appService.appObject.orderObject.is_tip_recurring = this.isTipRecurring;
    }, 10);
  }

  // navigate user to the menu page
  gobackToMenuPage(){
    if(!this.appService.isWebVersion){
      this.router.navigate(['restaurant', this.appService.appObject.selectedRestaurantDetails.slug]);
    }else{
      this.modalCtrl.dismiss();
    }
  }

  isExcludedPayentMethod(methodId: string): boolean {
    const excludedMethods = ['cod', 'paypal', 'stripe', 'ecCard', 'points','mollie','card_handled_by_waiter','cash_handled_by_waiter'];
    return excludedMethods.includes(methodId);
  }

  /**
 * This will redirect user to given route
 * @param location string value of route path
 */
  async navigateTo(slug) {
    if (!this.appService.isWebVersion)
      this.router.navigate([slug === 'tnc' ? '/pages/tnc' : '/pages/pnp'])
    else {
      this.onNavigatePages.emit([slug]);
    }
  }
}